import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {GET} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseAdminAPI');
const api = extendsAPIServices(baseAdminAPI);

export const _countPaidUsers = (args) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/statistics/paid-users`,
    });
};


// WEBPACK FOOTER //
// ./src/services/apis/StatisticsAPI.js